// Copyright (c) 2023, iPivot, Corp.
'use strict'

const axios = require('axios')
const { getTheme, imageUrl } = require('@ipivot/themes-base')

module.exports.availableThemes = async () => {
    const availableThemesFromRegistry = (await axios.get('/themes')).data

    if (availableThemesFromRegistry.length === 0) {
        availableThemesFromRegistry.push('default')
    }

    return availableThemesFromRegistry.map(theme => getTheme(theme))
}

module.exports.getDefaultTheme = async () => {
    return (await module.exports.availableThemes())[0]
}

module.exports.getImage = imageId => {
    return `${module.exports.imageUrl}/${imageId}`
}

module.exports.imageUrl = imageUrl
